import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { ProductConfigurator } from "~/features/product-configurator";
import { SENSOR_MODEL_BY_SELECTION } from "~/features/product-configurator/utils/scene-models";
import { takeFirst } from "~/features/app/utils";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { useLinkIcon } from "~/features/ui/link/use-link-icon";
export const sensorConfiguratorHeroFragment = graphql(`
  fragment SensorConfiguratorHero on hero_sensorConfiguratorHero_BlockType {
    configuratorSensor
    link: baseLink {
      ...Link
    }
  }
`);
type Props = FragmentType<typeof sensorConfiguratorHeroFragment> & {
  title?: string;
  caption?: string;
  tag?: string;
  highlights?: string[];
};
export function SensorConfiguratorHero({
  title,
  caption,
  tag,
  highlights,
  ...rest
}: Props) {
  const {
    configuratorSensor,
    link
  } = useFragment(sensorConfiguratorHeroFragment, rest);
  const baseModel = configuratorSensor && configuratorSensor in SENSOR_MODEL_BY_SELECTION ? configuratorSensor as keyof typeof SENSOR_MODEL_BY_SELECTION : undefined;
  const cta = takeFirst(link);
  const linkIcon = useLinkIcon(cta || undefined);
  return <ProductConfigurator title={title} caption={caption} tag={tag} highlights={highlights} baseModel={baseModel} cta={isLinkValid(cta) ? <Button as={Link} {...cta} variant="underline" icon={linkIcon} /> : undefined} />;
}